"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _EDSContext = require("../EDSContext/EDSContext");
var _excluded = ["activeStep", "steps", "edsContext"];
/**
 * A component that displays the current step of the total steps
 */
var MobileStepperCounter = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var activeStep = props.activeStep,
    steps = props.steps,
    edsContext = props.edsContext,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({
    variant: "body2"
  }, rest, {
    ref: ref
  }), edsContext.formatMessage('component.MobileStepper.step', {
    step: activeStep + 1 >= steps ? steps : activeStep + 1,
    count: steps
  }));
});
MobileStepperCounter.propTypes = {
  /**
   * Set the active step (zero based index). This should be the same value that is being sent to the <MobileStepper> component.
   */
  activeStep: _propTypes.default.number,
  /**
   * The total steps. This should be the same value that is being sent to the <MobileStepper> component.
   */
  steps: _propTypes.default.number.isRequired,
  /**
   * Props will be passed into the rendered `<Typography>` component.
   */
  props: _propTypes.default.object,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object
};
MobileStepperCounter.displayName = 'MobileStepperCounter';
var _default = (0, _EDSContext.withEDSContext)(MobileStepperCounter);
exports.default = _default;